import type { ReactNode } from 'react';

export const symbol_nest_wake_on_press: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M830-441q-20 0-35-15t-15-35v-259q0-20.83 15-35.42Q810-800 830.5-800t35 14.58Q880-770.83 880-750v259q0 20-14.58 35-14.59 15-35.42 15ZM301.63-120Q285-120 270-126.5T244-144L59-329q-9-9-9-21t8-21l36-37q14-14 31.5-21.5T162-432l78 18v-326q0-42 29-71t71-29q42 0 71 29t29 71v180h26q5 0 9.31 1 4.31 1 9.69 3l147 66q24 11 35.5 35.32Q679-430.35 674-404l-36.12 217.88Q633-157 610.2-138.5 587.39-120 558-120H301.63ZM294-180h281l43-249-183-83h-55v-228q0-18-11-29t-29-11q-18 0-29 11t-11 29v399l-154-33-23 23 171 171Zm0 0h281-281Z"
		/>
	</svg>
);
